// =======================
// == Animations/UnlockForm.js ==
// =======================
/*
  All of the animations for UnlockForm.js
*/

import Animator from './animator';
const { call, animations } = new Animator();
const animate = () => call('#unlockForm', animations.downAndOut);
export default animate;
